import React from 'react';
import './SearchResults.scss';

const SearchResults: React.FC = () => {
  return (
    <div className="search-results-page">
      <div className="container">
        <h1>Search Results</h1>
        <p>Your search results will appear here.</p>
      </div>
    </div>
  );
};

export default SearchResults; 